import { matchesRoutePrefix, stripLocalePrefix } from './lib/i18n/locale-path';
import { resolveSafeRelativeCallbackPath } from './lib/urls/safe-callback-url';

/**
 * The routes for the application
 */
export enum Routes {
  Root = '/',

  // public CMS pages
  Pricing = '/pricing', // change to /#pricing if you want to use the pricing section in homepage
  Contact = '/#contact',
  PrivacyPolicy = '/privacy',
  TermsOfService = '/terms',

  // auth routes
  Login = '/auth/login',
  AuthError = '/auth/error',
  AuthPopup = '/auth/popup',
  AuthExtension = '/auth/extension',
  AuthExtensionCallback = '/auth/extension/callback',

  // dashboard routes
  Dashboard = '/dashboard',
  History = '/history',
  Admin = '/admin',
  AdminV2PreviewFrame = '/admin-v2-preview-frame',
  AdminDashboard = '/admin/dashboard',
  AdminRisk = '/admin/risk',
  AdminFinance = '/admin/finance',
  AdminUsage = '/admin/usage',
  AdminUsers = '/admin/users',
  AdminPayments = '/admin/payments',
  AdminCms = '/admin/cms',
  AdminCmsPages = '/admin/cms/pages',
  AdminCmsBlueprints = '/admin/cms/blueprints',
  AdminCmsOverlays = '/admin/cms/overlays',
  AdminCmsAssets = '/admin/cms/assets',
  AdminCmsSiteShell = '/admin/cms/site-shell',
  AdminCmsWorkspace = '/admin/cms/workspace',
  AdminCmsTools = '/admin/cms/tools',
  AdminCmsPricingCheckout = '/admin/cms/pricing-checkout',
  AdminResources = '/admin/resources',
  AdminResourcesSettings = '/admin/resources/settings',
  AdminResourcesCategories = '/admin/resources/categories',
  AdminResourcesArticles = '/admin/resources/articles',
  // payment processing
  Payment = '/payment',
}

/**
 * The routes that can not be accessed by logged in users
 */
export const routesNotAllowedByLoggedInUsers = [Routes.Login];

/**
 * The routes that are protected and require authentication
 */
export const protectedRoutes = [
  Routes.History,
  Routes.Dashboard,
  Routes.Admin,
  Routes.AdminV2PreviewFrame,
  Routes.AdminDashboard,
  Routes.AdminRisk,
  Routes.AdminFinance,
  Routes.AdminUsage,
  Routes.AdminUsers,
  Routes.AdminPayments,
  Routes.AdminCms,
  Routes.AdminCmsPages,
  Routes.AdminCmsBlueprints,
  Routes.AdminCmsOverlays,
  Routes.AdminCmsAssets,
  Routes.AdminCmsSiteShell,
  Routes.AdminCmsWorkspace,
  Routes.AdminCmsTools,
  Routes.AdminCmsPricingCheckout,
  Routes.AdminResources,
  Routes.AdminResourcesSettings,
  Routes.AdminResourcesCategories,
  Routes.AdminResourcesArticles,
];

/**
 * The default redirect path after logging in
 */
export const DEFAULT_LOGIN_REDIRECT = Routes.Root;

export function getSafePaymentCallback(
  value: string | null | undefined,
  fallback: string
): string {
  const safeCallback = resolveSafeRelativeCallbackPath(value);
  if (!safeCallback) return fallback;

  const basePath = safeCallback.split(/[?#]/)[0];
  const normalizedBasePath = stripLocalePrefix(basePath);
  if (
    normalizedBasePath === Routes.Payment ||
    matchesRoutePrefix(normalizedBasePath, '/api') ||
    matchesRoutePrefix(normalizedBasePath, '/_next')
  ) {
    return fallback;
  }
  return safeCallback;
}
